import initRDKitModule from "@rdkit/rdkit";

let RDKitPromise = null;

export default function initRDKit() {
    if (!RDKitPromise) {
        RDKitPromise = initRDKitModule({
            locateFile: (file) => `/rdkit/${file}`,
        }).then((RDKit) => {
            window.RDKit = RDKit;
            return RDKit;
        });
    }
    return RDKitPromise;
}